import React, { useState } from 'react'
import * as st from '~/assets/styl/Dormitories.module.styl'
import * as stLoc from '~/assets/styl/Location.module.styl'
import { Lazyload, Button, Modal } from '~/components'
import cn from 'classnames'
import img1 from '~/assets/img/pai-filha-cafe.webp'
import img2 from '~/assets/img/fachada-detalhe.webp'
import { useLanguage } from '~/hooks'

export default function Apartments() {
  const [modal, setModal] = useState(-1)
  const { t } = useLanguage()
  return (
    <>
      <section className={cn(st.core, st.apartments)} id="Apartamentos">
        <div className={st.logo}>
          <span></span>
        </div>
        <Lazyload src={img1} className={st.img1} />
        <Lazyload src={img2} className={st.img2} />
        <div className={st.dorms}>
          <h2>{t('Apartments.title')}</h2>
          <h3>{t('Apartments.area')}</h3>
          <div className={st.links}>
            <Button onClick={() => setModal(0)} outlined>
              {t('Apartments.buttonTecnico')}
            </Button>
            <Button href="/#FaleConosco">
              {t('Apartments.buttonContact')}
            </Button>
          </div>
        </div>
      </section>

      <Modal
        open={modal === 0}
        onClose={() => setModal(-1)}
        className={stLoc.modal}
      >
        {(closeProps) => (
          <>
            <button {...closeProps}></button>
            <h3>{t('Apartments.details')}</h3>
            <ul className={st.modalList}>
              <li>{t('Apartments.list.item1')}</li>
              <li>{t('Apartments.list.item2')}</li>
              <li>{t('Apartments.list.item3')}</li>
              <li>{t('Apartments.list.item4')}</li>
              <li>{t('Apartments.list.item5')}</li>
              <li>{t('Apartments.list.item6')}</li>
              <li>{t('Apartments.list.item7')}</li>
              <li>{t('Apartments.list.item8')}</li>
              <li>{t('Apartments.list.item9')}</li>
              <li>{t('Apartments.list.item10')}</li>
              <li>{t('Apartments.list.item11')}</li>
              <li>{t('Apartments.list.item12')}</li>
              <li>{t('Apartments.list.item13')}</li>
            </ul>
          </>
        )}
      </Modal>
    </>
  )
}
